import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * General settings of the material, shared by every language.
 */
@Component({
    bindings: {
        chapterNavigation: '=',
        sourceLanguage: '=',
        automaticTranslationsEnabled: '=',
        isAiTranslationAvailable: '<',
        languages: '<',
        onClose: '&'
    },
    template
})
export default class {
    constructor (COMPANY_LANGUAGE_ENUM) {
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/settings/index.js